var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTourismus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Tourismus__Icn/40px/Legende/Tourismus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Tourismus__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Legende_Tourismus__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,7.75 L31,20 L27,19.999 L27,30 L13,30 L13,19.999 L9,20 L20,7.75 Z M25,20 L15,20 L15,28 L25,28 L25,20 Z M20,10.744 L13.484,17.999 L26.515,17.999 L20,10.744 Z",
    id: ".._.._src_svg_Icn_40px_Legende_Tourismus__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourismus);
export default __webpack_public_path__ + "static/media/Tourismus.89e800681af3faa0c59281517bfc5168.svg";
export { ForwardRef as ReactComponent };